import classNames from 'classnames';

import { Avatar } from '@/src/ui/Avatar/Avatar';

import styles from './AvatarGroup.module.scss';

export function AvatarGroup({ items, className, size }: AvatarGroup.Props) {
    return (
        <div
            className={classNames(styles.avatarGroup, className, {
                [styles.xs]: size === 'xs',
                [styles.sm]: size === 'sm',
                [styles.md]: size === 'md',
                [styles.lg]: size === 'lg',
                [styles.xl]: size === 'xl',
            })}
        >
            {items.map((item, index) => (
                <div style={{ zIndex: index }} key={index} className={styles.item}>
                    <Avatar {...item} size={size} className={styles.avatar} />
                </div>
            ))}
        </div>
    );
}

export namespace AvatarGroup {
    export type Props = {
        items: Avatar.Avatar[];
        className?: string;
        size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    };
}
